"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * normalizador del modulo MODULE_SECTION_IMAGE_SLIDER
 * @param {object} fields
 * @returns
 */
const sliderNormalizer = (data) => {
    try {
        let res = null;
        const { fields } = data;
        if (fields) {
            const { columImages } = fields;
            if (columImages && Array.isArray(columImages) && columImages.length > 0) {
                res = {
                    "Title-1": fields.title,
                    "Images-1": [],
                };
                columImages.map((image) => {
                    const { fields } = image;
                    res["Images-1"].push(fields.imgPath);
                });
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = sliderNormalizer;
//# sourceMappingURL=index.js.map